import React, {useState, useEffect} from 'react';
import clsx from 'clsx';

export default function VideoPlayer({
  video, embiggened = false, callbacks, productGroup = {}, ...props
}) {

  let { title, playerUrl } = video;

  // YOUTUBE
  let fullUrl = playerUrl +
    "?wmode=opaque&amp;autoplay=1&amp;mute=0&amp;enablejsapi=1";

  const handleEmbiggen = (evt) => {
    evt.stopPropagation();
    callbacks.setEmbiggened(true);
    return false;
  }

  return (
    <div className="relative w-full h-full">
      <iframe className="w-full aspect-3/2"
        allow="autoplay"
        title={title}
        src={fullUrl}
        allowTransparency="true"
        allowFullScreen="true"></iframe>

      <div className="text-center">
        {!embiggened && <a onClick={handleEmbiggen}>click to embiggen</a>}
      </div>
    </div>
  );
}

/*
 let sample = {
 "flavour": "video",
 "title": "Coverking Neosupreme Seat Covers",
 "sm": "https://i.ytimg.com/vi/ojtxfPP9Aa4/hqdefault.jpg",
 "playerUrl": "https://www.youtube.com/embed/ojtxfPP9Aa4",
 "galleryUrl": "https://www.youtube.com/watch?v=ojtxfPP9Aa4&mute=0",
 "i": 12
 }
 */


